import slickSlider from "../../common/slickSlider.js";

export default function initSlideShow(el, i) {
  document.querySelectorAll(".js-slideshow-slider").forEach((el) => {
    const slideshowTheme = parseInt(el.dataset.theme, 10);

    const customPaging = (slider, i) => {
      // leading zero for single digits, 01 - 99
      const number = `0${i + 1}`.slice(-2);

      return `<button type="button" class="dot link">${number}</button>`;
    };

    if (slideshowTheme === 2) {
      try {
        el.closest(".slideshow:last-child")
          .closest(".container")
          .classList.add("contains-last-background");
      } catch (err) {}
    }

    const conf =
      slideshowTheme === 1
        ? {
            prevArrow: null,
            nextArrow: null,
            customPaging,
          }
        : {
            dots: false,
            slidesToShow: 2,
            responsive: [
              {
                breakpoint: 779,
                settings: {
                  slidesToShow: 1,
                  slidestoScroll: 1,
                },
              },
            ],
          };

    slickSlider(el, conf, (event, slick, currentSlide) => {
      if (slideshowTheme === 1) {
        const slickDotsWidth = el
          .querySelector(".slick-dots")
          .getBoundingClientRect().width;

        el.style.setProperty("--l-slick-dots-width", `${slickDotsWidth}px`);
      }
    });
  });
}
